import { render, staticRenderFns } from "./App-Wrapper.vue?vue&type=template&id=52764f76&scoped=true&"
import script from "./App-Wrapper.vue?vue&type=script&lang=js&"
export * from "./App-Wrapper.vue?vue&type=script&lang=js&"
import style0 from "./App-Wrapper.vue?vue&type=style&index=0&id=52764f76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52764f76",
  null
  
)

export default component.exports